import { MessageCircle } from "lucide-react";
import { LINKS } from "../data/content";

export const MobileStickyCTA = () => (
    <div
        data-testid="mobile-sticky-cta"
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-bh-green/10 bg-white/95 backdrop-blur-md shadow-[0_-8px_28px_rgba(6,76,61,0.12)]"
    >
        <a
            href={LINKS.whatsappChat}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-cta-whatsapp"
            aria-label="Chat WhatsApp dengan panitia pendaftaran"
            className="flex items-center justify-center gap-2 py-4 text-sm font-bold uppercase tracking-[0.08em] text-bh-dark active:bg-bh-light"
        >
            <MessageCircle className="w-5 h-5 text-bh-green" aria-hidden="true" />
            WhatsApp
        </a>
        <a
            href="#daftar"
            data-testid="mobile-cta-daftar"
            className="flex items-center justify-center gap-2 py-4 text-sm font-bold uppercase tracking-[0.08em] bg-bh-green text-white active:bg-bh-dark"
        >
            Daftar
        </a>
    </div>
);
